<template>
	<div class="card" style="width: 1200px; margin: 0 auto">
		<el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px;position: relative;right:150px">
			<el-breadcrumb-item :to="{ path: '/' }"> <i class="el-icon-location" style="padding-right: 5px"></i>首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/other/'+article.moduleId }">{{ article.moduleName }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ article.title }}</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- <h2 >{{article.articleName}}</h2> -->
		<h2 style="text-align: center;font-weight: bold;margin-top: 20px;margin-bottom: 20px">{{article.articleName}}
		</h2>
		<span style="color: gray"> 日期: {{article.createTime}}</span>
		<div style="width: 100%;height:3px;border: 4px solid rgba(90,89,89,0.24);margin-bottom: 10px;margin-top: 10px">
		</div>
		<!-- <el-tag size="small">{{ article.moduleName }}</el-tag> -->
		<!-- <span> {{article.createTime}}</span> -->
		<p v-html="article.articleContent" />
	</div>
</template>

<script>
	import {
		getMarInfo
	} from "../api";

	export default {
		name: 'articles',
		data() {
			return {
				article: {
					articleName: null,
					createTime: null,
					articleContent: null,
				},
			}
		},
		created() {
			this.getMarquee();

		},
		mounted() {

		},
		methods: {
			getMarquee() {
				getMarInfo(this.$route.params.id).then(res => {
					this.article = res.data.data[0]
					this.article.createTime = res.data.data[0].createTime.split(' ')[0];
				})
			},

		}
	}
</script>

<style scoped>
	.card {
		width: 80%;
		margin: auto;
	}
</style>
